import { mapGetters, mapMutations } from 'vuex'
import { getRecommendFriend } from "_api/friend";
export default {
  computed: {
    ...mapGetters([
      'recommend_friends',
      'recommend_friends_over',
    ]),
  },
  methods: {
    async getRecommendFriend(get_more = false, limit = 20) {
      if (this.recommend_friends_over) return true
      const res = await getRecommendFriend({
        limit,
        offset: get_more ? this.recommend_friends.length : 0,
      });
      if (res.data.status == 'ok') {
        let d = res.data.result.heybox_friends || []
        d = d.filter(v => !this.recommend_friends.find(v2 => v2.user_id == v.user_id))
        if (d.length === 0) {
          this.SET_RECOMMEND_FRIENDS_OVER(true)
          return
        }
        this.SET_RECOMMEND_FRIENDS([
          ...this.recommend_friends,
          ...d,
        ])
      }
    },
    ...mapMutations([
      'SET_RECOMMEND_FRIENDS_OVER',
      'SET_RECOMMEND_FRIENDS',
    ]),
  }
}